import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import { convertToNumber } from 'grandus-lib/utils';
import { Fragment } from 'react';
import styles from './Styles.module.scss';
import Image from 'grandus-utils/wrappers/image/Image';
import get from 'lodash/get';
import IconRemove from '@/components/_other/icons/IconRemove';
import Link from 'next/link';

const SelectedParameters = ({ href, parameters, handleClick }) => {
  return (
    <>
      {map(parameters?.data, (parameter, index) => {
        const imageProps = parameter?.photoPath
          ? {
              photo: {
                path: parameter?.photoPath,
              },
              width: 30,
              height: 30,
              type: 'png',
              alt: `Ikona ${parameter?.value}`,
            }
          : {};

        if (parameter?.type === 'slider') {
          const parameterTitle = parameter?.urlTitle
            ? parameter?.urlTitle
            : parameter['v2-name'];

          const parameterValueValue = map(
            sortBy(parameter?.values, item => convertToNumber(item.value)),
            item => item.value,
          ).join(' - ');

          return (
            <Fragment
              key={`selected-category-parameter-${parameter?.id}-${index}`}
            >
              <div className={styles.filterItem}>
                <LocalizedLink
                  href={href(parameterTitle)}
                  onClick={()=>handleClick(parameterTitle)}
                  scroll={false}
                  prefetch={false}
                  className={`w-full ${styles.close}`}
                >
                  <IconRemove />
                </LocalizedLink>
                {imageProps?.photo?.path ? (
                  <Image {...imageProps} />
                ) : (
                  ''
                )}
                {parameterValueValue}
              </div>
            </Fragment>
          );
        }

        return (
          <Fragment
            key={`selected-category-parameter-${parameter?.id}-${index}`}
          >
            {map(parameter?.values, (parameterValue, index) => {
              const { id: parameterId, name: parameterName } = parameter;

              const parameterTitle = parameter?.urlTitle
                ? parameter?.urlTitle
                : parameter['v2-name'];

              const parameterValueId = get(
                parameterValue,
                'id',
                encodeURIComponent(parameterValue?.value),
              );
              const parameterValueValue = get(
                parameterValue,
                'value',
                get(parameterValue, 'name'),
              );
              const parameterValueTitle = encodeURIComponent(
                get(
                  parameterValue,
                  'urlName',
                  get(parameterValue, 'v2-value', parameterValueValue),
                ),
              );

              return (
                <div
                  key={`category-parameter-${parameterId}-${parameterValueId}-${index}`}
                  className={styles.filterItem}
                >
                  <Link
                    href={href(parameterTitle, parameterValueTitle)}
                    onClick={()=>handleClick(parameterTitle, parameterValueTitle)}
                    scroll={false}
                    className={styles.close}
                    prefetch={false}
                  >
                    <IconRemove />
                  </Link>
                  {imageProps?.photo?.path ? (
                    <Image {...imageProps} />
                  ) : (
                    ''
                  )}
                  {`${parameterName}: ${parameterValueValue}`}
                </div>
              );
            })}
          </Fragment>
        );
      })}
    </>
  );
};

export default SelectedParameters;
